import React from "react";

const GymLanding = () => {
  return (
    <main className="gymlanding">
      

      <nav className="gymlanding__navbar">
        <div className="gymlanding__navbar__content">
          <h4 className="gymlanding__navbar__content__logo heading-tertiary--main">
            Your Gym Name
          </h4>
          <div className="gymlanding__navbar__content__logo__span"></div>
        </div>
      </nav>

      <div className="gymlanding__hero">
        <div className="gymlanding__hero__container">
          <div className="gymlanding__backgroundimages--1"></div>
          <div className="gymlanding__backgroundimages--2"></div>
          <div className="gymlanding__backgroundimages--3"></div>
          <div className="gymlanding__backgroundimages--4"></div>
          <div className="gymlanding__hero__container__content">
            <h1 className="gymlanding__hero__container__content__heading heading-primary--main">
              Join the elites
            </h1>
            <p className="gymlanding__hero__container__content__paragraph paragraph--main">
              What it takes to build the fitness icon? A good environment, the
              people around you. We’ve made this place for people like you.
            </p>
            <div className="gymlanding__hero__container__content__buttons">
              <div className="gymlanding__hero__container__content__buttons__container">
                <button className="btn btn-md gymlanding__hero__container__content__buttons__container__primary">
                  Show more
                </button>

                <button className="btn btn-md gymlanding__hero__container__content__buttons__container__secondary">
                  Contact us
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="gymlanding__insidethegym">
        <div className="gymlanding__insidethegym__container">
          <div className="gymlanding__insidethegym__container__content">
            <div className="gymlanding__insidethegym__container__content__header">
              <h4 className="gymlanding__insidethegym__container__content__header__subtext heading-tertiary--sub">
                INSIDE OUR GYM
              </h4>
              <h2 className="gymlanding__insidethegym__container__content__header__heading heading-secondary--main">
                Look inside our gym
              </h2>
            </div>

            <div className="gymlanding__insidethegym__container__content__images">
              <div className="gymlanding__insidethegym__container__content__images__container">
                <img
                  src="https://images.unsplash.com/photo-1534438327276-14e5300c3a48?ixlib=rb-1.2.1&ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&auto=format&fit=crop&w=1350&q=80"
                  className="gymlanding__insidethegym__container__content__images__container__image"
                  alt="gym-inside-images"
                />
              </div>
              <div className="gymlanding__insidethegym__container__content__images__container">
                <img
                  src="https://images.unsplash.com/photo-1546483875-ad9014c88eba?ixlib=rb-1.2.1&ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&auto=format&fit=crop&w=1274&q=80"
                  className="gymlanding__insidethegym__container__content__images__container__image"
                  alt="gym-inside-images"
                />
              </div>
              <div className="gymlanding__insidethegym__container__content__images__container">
                <img
                  src="https://images.unsplash.com/photo-1558611848-73f7eb4001a1?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=1351&q=80"
                  className="gymlanding__insidethegym__container__content__images__container__image"
                  alt="gym-inside-images"
                />
              </div>
              <div className="gymlanding__insidethegym__container__content__images__container">
                <img
                  src="https://images.unsplash.com/photo-1571902943202-507ec2618e8f?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=1268&q=80"
                  className="gymlanding__insidethegym__container__content__images__container__image"
                  alt="gym-inside-images"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="gymlanding__testimonials">
      <div className="gymlanding__backgroundimages--5"></div>
      <div className="gymlanding__backgroundimages--6"></div>
        <div className="gymlanding__testimonials__container">
          <div className="gymlanding__testimonials__container__content">
            <div className="gymlanding__testimonials__container__content__header">
              <h5 className="gymlanding__testimonials__container__content__header__subtext heading-tertiary--sub">
                RESULT TALKS
              </h5>
              <h2 className="gymlanding__testimonials__container__content__header__heading heading-secondary--main">
                What our members say
              </h2>
            </div>

            <div className="gymlanding__testimonials__container__content__members">
              <div className="gymlanding__testimonials__container__content__members__container">
                <div className="gymlanding__testimonials__container__content__members__container__image">
                  <img
                    src="https://images.unsplash.com/photo-1500048993953-d23a436266cf?ixlib=rb-1.2.1&ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&auto=format&fit=crop&w=1349&q=80"
                    alt="gym-member-testimonial"
                    className="gymlanding__testimonials__container__content__members__container__image__container"
                  />
                </div>

                <div className="gymlanding__testimonials__container__content__members__container__about">
                  <h1 className="gymlanding__testimonials__container__content__members__container__about__heading heading-secondary--main">
                    Akshun Singh
                  </h1>
                  <p className="gymlanding__testimonials__container__content__members__container__about__paragraph paragraph">
                    What could be the best way to utilise my time and enegry and
                    give some time to work out here. All personal trainers are
                    very helpful. Gained 10 KG in 5 months.
                  </p>
                </div>
              </div>
              <div className="gymlanding__testimonials__container__content__members__container">
                <div className="gymlanding__testimonials__container__content__members__container__image">
                  <img
                    src="https://images.unsplash.com/photo-1500048993953-d23a436266cf?ixlib=rb-1.2.1&ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&auto=format&fit=crop&w=1349&q=80"
                    alt="gym-member-testimonial"
                    className="gymlanding__testimonials__container__content__members__container__image__container"
                  />
                </div>

                <div className="gymlanding__testimonials__container__content__members__container__about">
                  <h1 className="gymlanding__testimonials__container__content__members__container__about__heading heading-secondary--main">
                    Akshun Singh
                  </h1>
                  <p className="gymlanding__testimonials__container__content__members__container__about__paragraph paragraph">
                    What could be the best way to utilise my time and enegry and
                    give some time to work out here. All personal trainers are
                    very helpful. Gained 10 KG in 5 months.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="gymlanding__pricing">
        <div className="gymlanding__pricing__container">
          <div className="gymlanding__pricing__container__content">
            <div className="gymlanding__pricing__container__content__header">
              <h5 className="gymlanding__pricing__container__content__header__subtext heading-tertiary--sub">
                MONEY TALKS
              </h5>
              <h2 className="gymlanding__pricing__container__content__header__heading heading-secondary--main">
                How much you pay monthly
              </h2>
            </div>

            <div className="gymlanding__pricing__container__content__pricing">
              <h1 className="gymlanding__pricing__container__content__pricing__heading">
                449 ₹
              </h1>
              <h4 className="gymlanding__pricing__container__content__pricing__subheading">
                Per month
              </h4>
            </div>
          </div>
        </div>
      </div>

      <div className="gymlanding__contact">
      <div className="gymlanding__backgroundimages--7"></div>
        <div className="gymlanding__contact__container">
          <div className="gymlanding__contact__container__content">
            <div className="gymlanding__contact__container__content__header">
              <h5 className="gymlanding__contact__container__content__header__subtext heading-tertiary--sub">
                READY TO INQUIRE?
              </h5>
              <h2 className="gymlanding__contact__container__content__header__heading heading-secondary--main">
                Looks interested? Talk to us
              </h2>
            </div>

            <div className="gymlanding__contact__container__content__contact">
              <form className="gymlanding__contact__container__content__contact__form form">
                <input
                  type="name"
                  name="name"
                  className="form__input "
                  placeholder="Your name"
                  // onChange={handleInput}
                />

                <input
                  type="tel"
                  name="contactNo"
                  className="form__input "
                  placeholder="Your contact no."
                  // onChange={handleInput}
                />

                <button
                  className="form__submit btn btn-md"
                  type="button"
                  // onClick={handleSignIn}
                >
                  Send us
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>

      <div className="gymlanding__call">
        <div className="gymlanding__call__container">
          <div className="gymlanding__call__container__content">
            <div className="gymlanding__call__container__content__header">
              <h5 className="gymlanding__call__container__content__header__subtext heading-tertiary--sub">
                TALK TIME
              </h5>
              <h2 className="gymlanding__call__container__content__header__heading heading-secondary--main">
                Have a question? Call us
              </h2>
            </div>

            <div className="gymlanding__call__container__content__call">
              <a href="tel:0123456789">
                <button
                  className="form__submit btn btn-md"
                  type="button"
                  // onClick={handleSignIn}
                >
                  Call us
                </button>
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="gymlanding__footer">
        <div className="gymlanding__footer__container">
          <div className="gymlanding__footer__container__content">
            <h1 className="gymlanding__footer__container__content__heading">
              Build with ❤️ by MeshDesh in 🇮🇳
            </h1>
            <h4 className="gymlanding__footer__container__content__subheading">
              MeshDesh 2021
            </h4>
          </div>
        </div>
      </div>
    </main>
  );
};

export default GymLanding;
